export const blockIconsHardwareMouse = (
	<span className='material-symbols-outlined'>mouse</span>
);
